import api from '@/api';
import dayjs from 'dayjs';
import _ from 'lodash';
import { saveAs } from 'file-saver';

const initialState = {
	woListLoading: false,
	includeClosed: false,
	woSearchString: '',
	woTableFilterValue: '', // determines which result set to query
	allWOList: [],
};


export const types = {
    SET_STATE: 'WORKORDERVIEWALL/SET_STATE',
};


export const reducers = (state = initialState, action) => {

	switch (action.type) {
		case types.SET_STATE:
			return { ...state, ...action.data };

		default:
			return state;
	}

};

export const actions = {
	setState: (data) => ({ type: types.SET_STATE, data }),

	resetState: () => ({ type: types.SET_STATE, data: { ...initialState }}),

	getSNPedigreeFile: () => async (dispatch, getState) => {
		try {
			dispatch(actions.setState({woListLoading: true}));
			const response = await api.get('/workorders/sn_pedigree', { responseType: 'text' });
			console.log('API Response:', response);


				const csvData = response.csvData;
				console.log('SNPedigree', csvData);
	
				const makeCSVfile = (csv) => {
					try {
						//let dateParts = dayjs().local().format('DDMMYYYYHHMISS') + '.csv';
						//let saveName = 'SN_Pedigree_' + dateParts;
						let blob = new Blob([csv], { type: 'text/csv' });
						saveAs(blob);
					} catch (err) {
						console.error('Error occurred when attempting to create CSV file.', err);
					}
				};

				makeCSVfile(csvData);

		} catch (err) {
			console.log('Failed to create csv file.', err);
		}
		dispatch(actions.setState({woListLoading: false}));
	},


	loadWorkOrderList: (filterValue) => async (dispatch, getState) => {
		const state         = getState(),
			  includeClosed = state.workOrderViewAll.includeClosed;
		
		
		let route = '/workorders/all';
		
		if (filterValue === 'Employee') {
			route = '/workorders/employee';
		} else if (filterValue === 'Current') {
			route = '/workorders/employee/current';
		}

		dispatch(actions.setState({ woListLoading: true }));


		try {
			const results = await api.get(route, {
				params: {
					includeClosed
				}
			});

			dispatch(actions.setState({ allWOList: results.work_orders }));
		} catch (e) {
			console.log(e);
		}

		
		dispatch(actions.setState({ woListLoading: false }));
	},


};
